import React from 'react';
import {Checkbox, Container, FormControlLabel, Grid,} from "@mui/material";
import Typography from "@mui/material/Typography";
import {isDealerSite} from "../../../utils/utils";
import DealersConditions from "./DealersConditions";
import BookingConditions from "./BookingConditions";

const TermsConditions = ({acceptTerms, checkTerms}) => {

    const handlerOccupancy = (event) => {
        acceptTerms(event);
    }

    return (
        <Container maxWidth="lg">
            <Grid container direction="column" spacing={3} alignItems={"center"} justify={"center"}>
                <Grid item xs>
                    <Typography variant="h3" component="h3" align="center">
                        Please review our booking terms & conditions
                    </Typography>
                </Grid>
                <Grid item xs>
                    <div className={'termsContainer'}>
                        {isDealerSite() ? <DealersConditions /> : <BookingConditions />}
                    </div>
                </Grid>
                <Grid item xs>
                    <FormControlLabel
                        className={'cleanCheckbox'}
                        control={
                            <Checkbox checked={checkTerms}
                                      onChange={handlerOccupancy}
                                      name="terms"
                                      color="primary"/>
                        }
                        label="I have read and accept the Terms and Conditions."/>
                </Grid>
            </Grid>
        </Container>
    );
}

export default TermsConditions;
